/**
 * Converted from: https://code.amazon.com/packages/HandshakePainterAssets/blobs/mainline/--/base/src/js/common.js
 */
export var Platform;
(function (Platform) {
    Platform["ANDROID"] = "android";
    Platform["IOS"] = "ios";
    Platform["UNKNOWN"] = "unknown";
})(Platform || (Platform = {}));
export var Sma;
(function (Sma) {
    Sma["FACEBOOK"] = "facebook";
    Sma["INSTAGRAM"] = "instagram";
    Sma["PINTEREST"] = "pinterest";
    Sma["SNAPCHAT"] = "snapchat";
    Sma["TIKTOK"] = "tiktok";
    Sma["UNKNOWN"] = "unknown";
})(Sma || (Sma = {}));
export const smaDisplayName = {
    [Sma.FACEBOOK]: 'Facebook',
    [Sma.INSTAGRAM]: 'Instagram',
    [Sma.PINTEREST]: 'Pinterest',
    [Sma.SNAPCHAT]: 'Snapchat',
    [Sma.TIKTOK]: 'TikTok',
    [Sma.UNKNOWN]: Sma.UNKNOWN,
};
export const getMobileOperatingSystem = () => {
    const userAgent = navigator.userAgent;
    if (/android/i.test(userAgent)) {
        return Platform.ANDROID;
    }
    // @ts-expect-error Apparently MSStream doesn't exist but this is a copy/pasta from V1
    if (/ipad|iphone|ipod/i.test(userAgent) && !window.MSStream) {
        return Platform.IOS;
    }
    return Platform.UNKNOWN;
};
export const getSma = () => {
    const userAgent = navigator.userAgent;
    if (/instagram/i.test(userAgent)) {
        return Sma.INSTAGRAM;
    }
    if (/fb_iab|fbios/i.test(userAgent)) {
        return Sma.FACEBOOK;
    }
    if (/snapchat/i.test(userAgent)) {
        return Sma.SNAPCHAT;
    }
    if (/musical_ly/i.test(userAgent)) {
        return Sma.TIKTOK;
    }
    const tag = new URLSearchParams(window.location.search).get('tag');
    if (tag === null || tag === void 0 ? void 0 : tag.startsWith('pn')) {
        return Sma.PINTEREST;
    }
    return Sma.UNKNOWN;
};
